<section class="error-page White">
    <div class="grid-container">
        <h2>500 - Error</h2>
        <h4 class="subtext">The system has encountered an error.</h4>
        <div class="button-container">
            <a tabindex="0" class="btn primary-button" [routerLink]="['/']">Return to Home</a>
        </div>
    </div>
</section>
